import { Button } from 'app/components/ui/Button'
import { Modal } from 'app/components/ui/Modal'
import { Text } from 'app/components/ui/Text'
import React, { useState } from 'react'
import styled from 'styled-components'

import { UpdateUserEmailForm } from '../UpdateUserEmailForm'

type Props = { isVisible: boolean; onCloseRequest: () => void }

export const UpdateUserEmailModal = ({
  isVisible,
  onCloseRequest,
}: Props): JSX.Element => {
  const [showUpdateUserEmailConfirm, setShowUpdateUserEmailConfirm] =
    useState(false)

  return isVisible ? (
    <Modal
      onCloseRequest={() => onCloseRequest()}
      title={'Aggiorna la tua Email'}
    >
      {!showUpdateUserEmailConfirm ? (
        <UpdateUserEmailForm
          onSuccess={() => {
            setShowUpdateUserEmailConfirm(true)
          }}
        />
      ) : (
        <UpdateUserEmailConfirmWrapper>
          <Text variant='s24' weight='bold' mb={1}>
            Controlla il tuo indirizzo email
          </Text>
          <Text variant='s18' mb={2}>
            Controlla la tua casella di posta per confermare la nuova email.
          </Text>
          <Button onClick={() => onCloseRequest()}>Chiudi</Button>
        </UpdateUserEmailConfirmWrapper>
      )}
    </Modal>
  ) : (
    <></>
  )
}

const UpdateUserEmailConfirmWrapper = styled.div`
  text-align: center;
`
